import React from 'react'
import { makeStyles } from '@mui/styles'
import lkqLogoURL from 'assets/svg/LKQLogoWhite.svg'
import lkqBackground from 'assets/svg/lkq-background.svg'
const useStyles = makeStyles({
  customHeader: {
    width: '100%',
    height: 150,
    backgroundColor: '#000000',
    backgroundSize: 'cover',
    backgroundPosition: 'bottom',
    position: 'relative'
  },
  headerContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '16px 0 0 32px',
    boxSizing: 'border-box'
  },
  headerLogo: {
    height: 60,
    width: 'auto'
  },
  headerLKQBranding: {
    width: 'auto',
    height: '100%',
    position: 'absolute',
    right: 0
  }
})

const Header: React.FC = () => {
  const classes = useStyles()
  return (
    <header className={classes.customHeader}>
      <div className={classes.headerContent}>
        <img src={lkqLogoURL} alt='Logo' className={classes.headerLogo} />
      </div>
      <img src={lkqBackground} alt='LKQ Branding' className={classes.headerLKQBranding} />
    </header>
  )
}

export default Header
